// Initialisation au chargement
function initSummary() {
    var summary = document.querySelector('.js-summary-ancres')
    if (summary) {

        var sum_ancres = {
            selectors: {
                barreAncres: '.js-summary-ancres',
                blocAncre: '.js-summary-content',
                linkAncre: '.js-summary-ancres-link',
            },
            scrollMobileOffset: 120,
            scrollOffset: 141,
            scrollSpeed: 500,

            init: function () {
                sum_ancres.ancreClick();
                sum_ancres.observer();
            },

            // Gestion du scroll smooth
            ancreClick: function () {
                var links = document.querySelectorAll(sum_ancres.selectors.linkAncre);
                links.forEach(link => {
                    link.addEventListener('click', function (e) {
                        e.preventDefault();
                        var targetId = this.getAttribute('href');
                        var target = document.querySelector(targetId);

                        if (target) {
                            var top = target.getBoundingClientRect().top + window.scrollY - sum_ancres.scrollOffset;
                            if (isDeviceMobile) {
                                top = target.getBoundingClientRect().top + window.scrollY - sum_ancres.scrollMobileOffset;
                            }
                            window.scrollTo({
                                top: top,
                                behavior: 'smooth'
                            });

                            // Mise au focus pour l'accessibilité
                            target.setAttribute('tabindex', '-1');
                            target.focus({preventScroll: true});
                            if (isDeviceMobile) {
                                closeSummary();
                            }
                        }
                    });
                });
            },

            // Callback de l'Intersection Observer
            obsCallback: function (entries, observer) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        var entryId = entry.target.id;

                        // Désactiver tous les liens
                        var links = document.querySelectorAll(sum_ancres.selectors.linkAncre);
                        links.forEach(link => {
                            link.classList.remove('is-active');
                            link.removeAttribute('aria-current');
                        });

                        // Activer le lien correspondant
                        var currentLink = document.querySelector(`${sum_ancres.selectors.linkAncre}[href="#${entryId}"]`);
                        if (currentLink) {
                            currentLink.classList.add('is-active');
                            currentLink.setAttribute('aria-current', 'true');
                        }
                    }
                });
            },

            // Initialisation de l'observer
            observer: function () {
                if ('IntersectionObserver' in window) {
                    var observerOptions = {
                        root: null,
                        rootMargin: '0px 0px -50% 0px',
                        threshold: 0
                    };

                    var observer = new IntersectionObserver(sum_ancres.obsCallback, observerOptions);

                    var targets = document.querySelectorAll(sum_ancres.selectors.blocAncre);
                    targets.forEach(target => {
                        observer.observe(target);
                    });
                }
            },
        };

        sum_ancres.init();

        var toggleSummaryBtn = summary.querySelector(':scope .js-summary-btn');
        var summaryLinks = summary.querySelectorAll(':scope .js-summary-ancres-link');

        if (!isDeviceMobile) {
            summaryLinks.forEach(link => {
                link.setAttribute('tabindex', '0')
            })
        }

        function openSummary() {
            summary.classList.add('open');
            summaryLinks.forEach(link => {
                link.setAttribute('tabindex', '0')
            })
            toggleSummaryBtn.setAttribute('aria-expanded', 'true')
        }

        function closeSummary() {
            summary.classList.remove('open');
            summaryLinks.forEach(link => {
                link.setAttribute('tabindex', '-1')
            })
            toggleSummaryBtn.setAttribute('aria-expanded', 'false')
        }

        toggleSummaryBtn.addEventListener('click', () => {
            if (summary.classList.contains('open')) {
                closeSummary();
            } else {
                openSummary();
            }
        });

        window.addEventListener('resize', () => {
            if (!isDeviceMobile && summary.classList.contains('open')) {
                closeSummary();
                summaryLinks.forEach(link => {
                    link.setAttribute('tabindex', '0')
                })
            }
        })
    }
}

initSummary()

if (typeof Liferay !== 'undefined') {
    Liferay.on('endNavigate', () => {
        initSummary()
    })
}

